import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import Eye from "../assets/eye.svg";
import Input from "../form-components/Input";
import Header from "./Header";
import "./styles/login.css";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { reset_sessions, sessions, logout } from "../actions/auth/Action";
import { toast } from "react-toastify";
import { startIdleTimer } from "../../admin/config/helper.js";

const LoginSchema = Yup.object().shape({
  email: Yup.string().required("Email is required"),
  password: Yup.string().required("Password is required."),
});

export const HomeWrapper = (props) => {
  return (
    <div className="login flex-end">
      <Header />
      <div className="w45 login-form">
        <div className="w100">
          {props.children}
          <div className="footer-text">
            <span className="text-sub-heading">
              Don’t have an account yet?{" "}
            </span>
            <a href="mailto:info@omni-united.com">
              <span>Contact Administrator</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const loginRes = useSelector((state) => state.auth.sessions);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    onSubmit: (vals) => {
      dispatch(sessions(vals));
    },
    validationSchema: LoginSchema,
  });

  useEffect(() => {
    if (loginRes && loginRes.success) {
      toast.success("Login Success");
      localStorage.setItem("token", loginRes?.data?.authentication_token);
      localStorage.setItem("expiresAt", loginRes?.data?.authentication_token_expires_at);
      localStorage.setItem("email", loginRes?.data?.email);
      localStorage.setItem("permissions", loginRes?.data?.permissions);
      localStorage.setItem("is_super_admin", true);
      const expiresIn = localStorage.getItem('expiresAt') - Date.now();
      const logoutBefore = expiresIn - 20000;// 20 seconds before expiry

      const onLoginTimeout = () => {
      const email = localStorage.getItem("email")
  
      dispatch(logout({ email }));
  
      // Delay clearing to ensure logout API gets token
        setTimeout(() => {
          localStorage.clear();
          toast.info("Session expired due to inactivity.");
          history.push("/admin/");
        }, 1000); // wait 1s before clearing (enough for logout API)
      };
  
      startIdleTimer(onLoginTimeout);

      dispatch(reset_sessions());
      history.push(`/admin/${loginRes?.data?.permissions?.length ? loginRes?.data?.permissions?.[0] : "customers"}`);
    }

    if (loginRes && loginRes.success === false) {
      toast.error(loginRes?.data?.message);
      dispatch(reset_sessions());
    }
    // eslint-disable-next-line
  }, [loginRes]);

  return (
    <HomeWrapper>
      <form className="flex-center" onSubmit={formik.handleSubmit}>
        <div className="w60">
          <div className="head-sec">
            <h3 className="text-heading">Welcome Back</h3>
            <span className="text-sub-heading">
              Please sign in to your account.
            </span>
          </div>
          <Input
            placeholder={"Enter email"}
            formik={formik}
            name="email"
            type="email"
          />
          <Input
            placeholder="Enter password"
            icon={Eye}
            formik={formik}
            name="password"
            type="password"
          />
          {/* <div className="terms">
            <span className="check">
              <img alt="check" src={check} />
            </span>
            I have agreed to the <span>Terms of Conditions</span> and{" "}
            <span>Privacy Policy</span>
          </div> */}
          <div className="v-center mt2">
            <button
              className={`primary-btn mr1 ${loginRes?.loading ? "loadBtn" : ""
                }`}
              type="submit"
            >
              {loginRes?.loading ? "Processing..." : "Login"}
            </button>
            <span
              className="p-link "
              onClick={() => {
                history.push("/admin/reset-password");
              }}
            >
              Forgot password ?
            </span>
          </div>
        </div>
      </form>
    </HomeWrapper>
  );
};

export default Login;
